import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                               from '@angular/forms';

import { MessagesService }           from '../messages/messages.service';
import { PurchaseRequestCostModel }  from './typings/uk-postcode.purchase-request.cost';
import { PurchaseRequestQuoteModel } from './typings/uk-postcode.purchase-request.quote';
import { UKPostcodeService }         from './uk-postcode.service';

@Component({
  selector   : 'wor-uk-postcode-purchase-requests',
  template: require('./uk-postcode.purchase-requests.component.html')
})
export class UKPostcodePurchaseRequestsComponent {
  @BlockUI('purchaseRequestsBlock') block : NgBlockUI;

  @Input() cost: PurchaseRequestCostModel;

  quote = {} as PurchaseRequestQuoteModel;

  constructor (
    public  activeModal      : NgbActiveModal,
    private messagesService  : MessagesService,
    @Inject(forwardRef(() => UKPostcodeService))
    private ukPostcodeService: UKPostcodeService
  ) {}

  confirm ( form : NgForm ) : void {
    this.block.start();

    this.ukPostcodeService.confirmPurchase(this.quote)
    .then(() => {
      this.activeModal.close();
    })
    .catch(err => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  updatePrice () : void {
    this.quote.price = this.ukPostcodeService.getQuotedPrice(this.cost, this.quote);
  }
}
